import { css } from "@emotion/react";

import { fontBarlow, fontPlayfairDisplay, theme } from "shared/lib/styles";

import { AdSlotContainer } from "scmp-app/components/advertisement/ad-slots/ad-slot/styles";
import { getClassNameFromSize } from "scmp-app/components/advertisement/ad-slots/helpers";
import {
  ArticleImageContainer,
  DescriptionContainer as ArticleImageDescriptionContainer,
  StyledImage,
} from "scmp-app/components/article/article-image/styles";
import { InstagramContainer } from "scmp-app/components/schema-render/common/blockquote/styles";
import { TweetContainer } from "scmp-app/components/schema-render/common/blockquote/twitter/styles";
import {
  Heading1,
  Heading2,
  Heading3,
  Heading4,
} from "scmp-app/components/schema-render/common/heading/styles";
import { StyledSCMPYoutubeVideo } from "scmp-app/components/schema-render/common/iframe/scmp-youtube/styles";
import {
  InlineNativeSlot,
  InlineOutstreamAdSlot,
  InlineSlot,
} from "scmp-app/components/schema-render/common/inline-ad-slot/styles";
import { Container as InlineWidgetContainer } from "scmp-app/components/schema-render/common/inline-widget/styles";
import { Paragraph } from "scmp-app/components/schema-render/common/paragraph";
import {
  StyledLi,
  StyledOl,
  StyledStrong,
  StyledUl,
} from "scmp-app/components/schema-render/content/styles";

export const pageStyle = () => css`
  color: #000000;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontBarlow};
  line-height: 32px;
  letter-spacing: -0.09px;

  font-variant-numeric: lining-nums proportional-nums;

  ${theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 33px;
    letter-spacing: normal;
  }

  ${Heading1},
  ${Heading2},
  ${Heading3} {
    margin-block-start: 48px;

    font-weight: 400;
    font-size: 24px;
    font-family: ${fontPlayfairDisplay};
    line-height: 33px;

    ${theme.breakpoints.up("tablet")} {
      font-size: 32px;
      line-height: normal;
    }
  }

  ${Heading4} {
    padding-block: 15px 2px;

    font-weight: 400;
    font-size: 18px;
    font-family: ${fontPlayfairDisplay};
    line-height: 23px;

    ${theme.breakpoints.up("tablet")} {
      font-size: 20px;
      line-height: 27px;
    }
  }

  ${StyledStrong} {
    font-weight: 600;
  }

  ${Paragraph} {
    margin-block-start: 48px;

    a {
      color: #000000;
      font-size: 18px;
      line-height: 32px;
      letter-spacing: -0.09px;
      text-decoration-line: underline;
      text-decoration-thickness: 1px;

      ${theme.breakpoints.up("desktop")} {
        font-size: 20px;
        line-height: 33px;
        letter-spacing: normal;
      }
    }
  }

  ${StyledOl} {
    margin-block-start: 33px;

    list-style: decimal;
  }

  ${StyledUl} {
    margin-block-start: 33px;

    list-style: disc;
  }

  ${StyledLi} {
    margin-inline-start: 36px;
    padding-block-end: 8px;
    padding-inline-start: 4px;

    ${Paragraph} {
      margin-block-start: 0;
    }
  }

  ${InlineWidgetContainer} {
    margin-block-start: 48px;

    overflow-wrap: anywhere;
  }

  /*
    NOTE: need this styling to ensure strike through is applied to the anchor as well - currently
    there is a conflict from display: inline-block coming from global-styles.tsx for anchor
  */
  s {
    a {
      display: inline;
    }
  }

  ${InlineSlot}, ${InlineOutstreamAdSlot}, ${InlineNativeSlot} > ${AdSlotContainer} {
    :not(
      .${getClassNameFromSize({ height: 0, width: 0 })},.${getClassNameFromSize({
          height: 1,
          width: 1,
        })}
    ) {
      margin-block: 40px -8px;

      ${theme.breakpoints.up("tablet")} {
        margin-block-start: 48px;
      }
    }
  }

  ${ArticleImageContainer} {
    margin-block-start: 40px;
    padding-inline: 20px;

    ${theme.breakpoints.up("tablet")} {
      margin-block-start: 64px;
      margin-inline: -47px;
      padding-block-start: 16px;
      padding-inline: 0;
    }

    ${theme.breakpoints.up("desktop")} {
      margin-inline: -90px;
    }
  }

  ${ArticleImageContainer}, ${ArticleImageDescriptionContainer}, ${StyledImage} {
    ${theme.breakpoints.up("tablet")} {
      max-inline-size: 676px !important;
    }

    ${theme.breakpoints.up("desktop")} {
      max-inline-size: 840px !important;
    }
  }

  ${ArticleImageDescriptionContainer} {
    color: #777777;
    font-size: 14px;
    font-family: ${fontPlayfairDisplay};
    font-style: italic;
    line-height: 20px;

    ${theme.breakpoints.up("tablet")} {
      line-height: 22px;
    }
  }

  .methode-html-wrapper,
  .video-wrapper {
    margin-block-start: 48px;

    ${TweetContainer}, ${InstagramContainer} {
      margin: 0;
    }

    ${StyledSCMPYoutubeVideo} {
      ${theme.breakpoints.only("mobile")} {
        position: unset;
        inset-inline-start: unset;
        inset-inline-end: unset;

        inline-size: 100%;
        margin-inline: 0;
      }
    }
  }
`;
